import {cardImages} from '../../assets/ImageIndex'
import { useIsDesktopOrLaptop } from '../../styles/theme'
import { useIsMiniNotebook } from '../../styles/theme'
import { useIsMobileBig } from '../../styles/theme'
import { useIsMobileMedium } from '../../styles/theme'
import { useIsMobileMini } from '../../styles/theme'
import React, { lazy, Suspense } from "react";

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  label?: string;
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

interface RenderCardElementProps {
  element: ElementType;
}

interface PostType {
  date: string;
  description: string;
  elements: ElementType[]; // Reutilizando a definição de ElementType
}

interface CardProps {
  post: PostType;
}

export const RenderCardElement: React.FC<RenderCardElementProps> = ({element }) => {
  const breakpoints = {
    isDesktopOrLaptop: useIsDesktopOrLaptop(),
    isMiniNotebook: useIsMiniNotebook(),
    isMobileBig: useIsMobileBig(),
    isMobileMedium: useIsMobileMedium(),
    isMobileMini: useIsMobileMini(),
  };
  
    switch (element.type) {
      case 'title':
        return (
          <h2 style={element.getStyles(breakpoints)}>
            {element.content as string}
          </h2>
          );
      
      case "link":
        if (typeof element.content === 'string') {
          return (
            <a href={element.content} 
                style={element.getStyles(breakpoints)} 
                target="_blank" 
                rel="noopener noreferrer"
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#007bff"}
                >
              {element.label || element.content}
            </a>
          );
        }
      return null;

      case 'text':
        console.log('breakpoints aplicados à text:', breakpoints);
        if (/<[a-z][\s\S]*>/i.test(element.content as string)) {
          return (
            <p
              style={element.getStyles?.(breakpoints)}
              dangerouslySetInnerHTML={{ __html: element.content as string }}
            />
          );
        }
          // Renderiza texto simples se não houver HTML
          return <p style={element.getStyles?.(breakpoints)}>{element.content as string}</p>;
      case 'image':
        return (
          <img src={element.content as string} alt="" loading="lazy" style={element.getStyles?.(breakpoints)} />
          );
      case 'list':
        return (
          <ul style={element.getStyles?.(breakpoints)}>
            {(element.content as string[]).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        );
        case 'div':
          return (
            <div style={element.getStyles?.(breakpoints)}>
              {(element.content as ElementType[]).map((subElement, index) => (
                <Suspense fallback={<div>Carregando...</div>} key={index}>
                  <RenderCardElement key={index} element={subElement} />
                </Suspense>
              ))}
            </div>
          );
      case 'br':
        return <br style={element.getStyles(breakpoints)} />;
      default:
        return null;
    }
  };
  
